(function () {
	'use strict';

	var root = document.querySelector('[data-property-share]');
	if (!root) return;

	var trigger = root.querySelector('[data-share-native]');
	var options = root.querySelector('.imovel-share__options');
	var copyButton = root.querySelector('[data-copy-property-link]');
	var feedback = root.querySelector('[data-share-feedback]');
	var title = root.dataset.shareTitle || document.title;
	var url = root.dataset.shareUrl || window.location.href;

	function showOptions() {
		options.hidden = false;
		trigger.setAttribute('aria-expanded', 'true');
	}

	function setFeedback(message) {
		feedback.textContent = message;
		window.setTimeout(function () { feedback.textContent = ''; }, 3000);
	}

	trigger.addEventListener('click', function () {
		if (navigator.share) {
			navigator.share({ title: title, text: title, url: url }).catch(function (error) {
				if (error && error.name !== 'AbortError') showOptions();
			});
			return;
		}
		var opening = options.hidden;
		options.hidden = !opening;
		trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
	});

	copyButton.addEventListener('click', function () {
		var copied = navigator.clipboard && window.isSecureContext
			? navigator.clipboard.writeText(url)
			: new Promise(function (resolve, reject) {
				var input = document.createElement('textarea');
				input.value = url;
				input.setAttribute('readonly', '');
				input.style.position = 'fixed';
				input.style.opacity = '0';
				document.body.appendChild(input);
				input.select();
				try { document.execCommand('copy') ? resolve() : reject(); } catch (error) { reject(error); }
				input.remove();
			});
		copied.then(function () { setFeedback('Link copiado'); }).catch(function () { setFeedback('Não foi possível copiar. Selecione o endereço do navegador.'); });
	});
}());
